import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl, useAppRoutes } from '@webapp/hooks'
import { CustomizePurchaseOrderFormView } from '@webapp/modules/purchasing/feature-sets/CustomizePurchaseOrderFormView'
import messages from './messages'

export const CustomizePurchaseOrderFormPageTabTypes = {
  CUSTOM_FIELDS: 'custom-fields',
  DISCLAIMER: 'disclaimer',
  SHIPPING_TERMS: 'shipping-terms',
  PAYMENT_TERMS: 'payment-terms',
  SHIPPING_METHODS: 'shipping-methods',
  PO_PDF_LABELS: 'po-pdf-labels',
  PO_PDF_CUSTOM_FIELDS: 'po-pdf-custom-fields',
} as const

export type CustomizePurchaseOrderFormPageTab =
  (typeof CustomizePurchaseOrderFormPageTabTypes)[keyof typeof CustomizePurchaseOrderFormPageTabTypes]

export interface CustomizePurchaseOrderFormPageParams {
  tab?: CustomizePurchaseOrderFormPageTab
}

export const CustomizePurchaseOrderFormPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.customizePurchaseOrderFormTitle)}
      breadcrumbs={[
        {
          link: url('SettingsPage'),
          name: intl.formatMessage(messages.settingsTitle),
        },
        {
          link: url('CustomizePurchaseOrderFormPage', {}),
          name: intl.formatMessage(messages.customizePurchaseOrderFormTitle),
        },
      ]}
    >
      <CustomizePurchaseOrderFormView />
    </Page>
  )
}
